export default __webpack_public_path__ + "static/media/RTR1604V_LateralDer.11f50667.webp";